/**
 * Customer-facing credit denomination.
 *
 * Internal billing remains ACU/capacity units. Public credits are intentionally smaller,
 * human-scale units so plan balances are comparable with mainstream AI builders.
 *
 * 1 customer credit = 10 internal ACU.
 * This is a display/accounting denomination only; provider economics and settlement remain
 * authoritative in creditPolicy.ts and the ACU ledger.
 */
export const INTERNAL_ACU_PER_CUSTOMER_CREDIT = 10;

export function customerCreditsFromAcu(acu:number):number{
  if(!Number.isFinite(acu)||acu<=0)return 0;
  return acu/INTERNAL_ACU_PER_CUSTOMER_CREDIT;
}

export function customerCreditsDisplayFromAcu(acu:number):string{
  return customerCreditsFromAcu(acu).toLocaleString(undefined,{minimumFractionDigits:0,maximumFractionDigits:2});
}
